/**************************************************
 * Nombre:       Tarjeta_Plan_Estudios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";
import {ArrowDownwardOutlined, ArrowUpwardOutlined, FiberManualRecord} from '@mui/icons-material'
import {useState} from "react";


const Tarjeta_Plan_Estudios = () => {
    const [open, setOpen] = useState(false);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                p: 3,
                color: '#fff'
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontFamily: NEGRITA, fontSize: 32,}}>SEMESTRE 1</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 18, lineHeight: 1.3}}>
                    Domina las bases de la gestión documental, herramientas digitales y procesos administrativos
                    esenciales.
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'center'}}>
                <IconButton
                    onClick={() => setOpen(!open)}
                >
                    {!open ?
                        <ArrowDownwardOutlined sx={{fill: '#fff'}}/>
                        :
                        <ArrowUpwardOutlined sx={{fill: '#fff'}}/>
                    }

                </IconButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Collapse sx={{width: '100%'}} in={open}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{mt: 2}}
                    >

                        {items.map((item, index) => (
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                <Typography>
                                    <FiberManualRecord sx={{fill: '#fff', width: 12, height: 12, pr: 1}}/>
                                    Lorem impuis dolor sae nart erot lorem sisgo nerto cualo</Typography>
                            </Grid>
                        ))}

                    </Grid>
                </Collapse>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Plan_Estudios

const items = [
    1, 2, 3, 4, 5, 6,
]